var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenContent6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54.167px",
    height: "64.583px",
    viewBox: "0 0 54.167 64.583",
    enableBackground: "new 0 0 54.167 64.583",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F8A99F",
    points: "53.761,57.836 45.646,64.184 0.75,6.813 8.866,0.465  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenContent6);
export default __webpack_public_path__ + "static/media/screen_content6.e35616a9d3c7d59d8b5074350d827346.svg";
export { ForwardRef as ReactComponent };